import * as React from "react";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import DropDown from "../../../../hiberUiKit/src/molecules/DropDown/DropDown";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import Merchant from "../../../../model/merchant/Merchant";
import MerchantBranchLocation from "../../../../model/merchant/MerchantBranchLocation";

interface ComponentProps {
	/**
	 * Selected type id.
	 */
	selectedTypeId: string;
	/**
	 * On select action callback.
	 */
	onSelect: (type: DictionaryItem) => void;
	/**
	 * Lead/job types.
	 */
	types: DictionaryItem[] | Merchant[] | MerchantBranchLocation[];
	/**
	 * Info module title.
	 */
	title?: string;
	/**
	 * Drop down placeholder.
	 */
	placeholder?: string;
	/**
	 * Indicates if input field has clear icon.
	 */
	clearable?: boolean;
	/**
	 * Clear icon click callback
	 */
	onClearClick?: () => void
	/**
	 * Indicates if dropdown is disabled
	 */
	disabled?: boolean
}

type Props = ComponentProps

export default class TypeDropdown extends React.PureComponent<Props, {}> {
	public static defaultProps: Partial<Props> = {
		title: "LEAD TYPE",
		placeholder: "Select lead type"
	};

	render() {
		return (
			<InfoModule icon={Icon.Job} title={this.props.title}>
				<DropDown items={this.props.types}
						  itemToId={(item: DictionaryItem) => item.id}
						  itemToLabel={(item: DictionaryItem) => item.name}
						  selectedItemId={this.props.selectedTypeId}
						  placeholder={this.props.placeholder}
						  onSelect={this.props.onSelect}
						  clearable={this.props.clearable}
						  disabled={this.props.disabled}
						  onClearClick={this.props.onClearClick}/>
			</InfoModule>
		);
	}
}
